<template>
  <ubi-panel>
    <div v-if="networkName !== 'Video' && networkName !== 'Home'">
      <el-container>
        <el-aside width="30%">
          <h3>{{titleH3}}</h3>
          <p class="text-justify mt-3">{{textAside}}</p>
          <h3 class="text-justify mt-3">{{titleH3Info}}</h3>
          <p class="text-justify mt-3">{{textAsideInfo1}}</p>
          <p class="text-justify mt-n3">{{textAsideInfo2}}</p><br/>
          <h3 class="text-justify ">{{titleWarning}}</h3>
          <p class="text-justify mt-3"><strong>{{textWarning}}</strong></p>
          <DateTimePickerPost
              :isDatePickerVisible="isDatePickerVisible || checkIsVisibleDatePicker"
              ref="datePicker"
              :status-post="statusPost"
              :datePost.sync="datePost"
              :getDatePost="getDatePost"
              :getStatusPost="getStatusPost"
              @validateDateTime="validateDateTime"
              @lostFocusDatePicker="lostFocusDatePicker"
              :isCurrentlyPublished="isCurrentlyPublished"
              :possedeNetwork="possedeRS"
              :editSchedule="editSchedule"/>
        </el-aside>
        <el-main v-if="possedeSocialNetwork" class="main-container">
          <el-row>
            <el-col :span="24">
              <h4>{{ titleH4 }}</h4>
              <p>{{textInfoTextarea1}}</p>
              <p class="paragrah">{{textInfoTextarea2}}</p>
              <p><strong>{{titleWarning}}!</strong> {{textInfoIA}}</p>
<!--              Personnalisation des prompts-->
              <el-form-item v-if="hasOptionIaAndPersoPrompt">
                <el-row :gutter="24">
                  <el-col :span="9">
                    <el-select v-model="selectedPrompt" filterable :placeholder="$t('prompt.selectedPrompt')" style="margin-bottom: 15px;" @change="handleSelectedPrompt()" clearable size="medium" :disabled="caption && caption.text !== ''">
                      <el-option
                          v-for="prompt in getLibrariePrompt"
                          :key="prompt.id"
                          :label="prompt.titre"
                          :value="prompt.id">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="9" class="mr-2" >
                    <el-button @click="redirectToPromptsLibraries"  type="primary" size="medium" style="margin-bottom: 15px;" :disabled="caption && caption.text !== ''">
                      {{ $t('prompt.defineNewInstruction') }}
                    </el-button>
                  </el-col>
                  <el-col :span="5">
                    <el-button @click="resetCaption" style="margin-bottom: 15px;" size="medium" v-if="caption && caption.text !== ''">{{ $t('posts.edit.resetCaption') }}
                    </el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <div class="wait-captionIA" v-if="getLoadingCaption">
                      <p>{{ $t('posts.IA.textSpinnerIA') }}</p>
                      <div><Stretch /></div>
                    </div>
                    <div class="textarea-with-emojis" v-else>
                      <el-input :rows="8" type="textarea" :disabled="(statusPost === 'isCurrentlyPublished') || isCurrentlyPublished || getStatusPost === 'published'"
                                v-model="caption.text"
                                v-if="caption"
                                ref="textareaNetwork"
                      >
                      </el-input>
                      <div v-if="!isAlreadyPublished && caption">
                        <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
  <!--              OptionIA -->
              <el-form-item v-if="hasOnlyOptionIa">
                <el-button @click="resetCaption" style="margin-bottom: 15px;" v-if="caption" :disabled="isCurrentlyPublished || getStatusPost === 'published'">{{ $t('posts.edit.resetCaption') }}</el-button>
                <el-row>
                  <el-col>
                    <div class="wait-captionIA" v-if="caption.text === ''">
                      <p v-if="IAoptionActive">{{ $t('posts.IA.textSpinnerIA') }}</p>
                      <div><Stretch /></div>
                    </div>
                    <div class="textarea-with-emojis" v-else >
                      <el-input :rows="8" type="textarea" :disabled="(statusPost === 'isCurrentlyPublished') || isCurrentlyPublished || getStatusPost === 'published'"
                                v-model="caption.text"
                                v-if="caption"
                                ref="textareaNetwork"
                      >
                      </el-input>
                      <div v-if="(statusPost !== 'isCurrentlyPublished') && caption && !isCurrentlyPublished || getStatusPost === 'published'">
                        <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
  <!--              Flux -->
              <el-form-item v-if="hasFlux">
                  <el-button @click="resetCaption" style="margin-bottom: 15px;" v-if="caption" :disabled="isCurrentlyPublished || getStatusPost === 'published'">{{ $t('posts.edit.resetCaption') }}</el-button>
                  <el-row>
                    <el-col>
                      <div class="textarea-with-emojis" v-loading="getLoadingCaption" >
                        <el-input :rows="8" type="textarea" :disabled="(statusPost === 'isCurrentlyPublished') || isCurrentlyPublished || getStatusPost === 'published'"
                                  v-model="caption.text"
                                  v-if="caption"
                                  ref="textareaNetwork"
                        >
                        </el-input>
                        <div v-if="(statusPost !== 'isCurrentlyPublished') && caption && !isCurrentlyPublished || getStatusPost === 'published'">
                          <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              <PostVideoFileUrlCustom @updateValue="setError" @change-tab="updateCurrentTab" :data="{'post':post, 'networkName':networkName, 'statusPost':statusPost, 'isCurrentlyPublished':isCurrentlyPublished}"></PostVideoFileUrlCustom>
            </el-col>
          </el-row>
        </el-main>
        <el-main v-else>
          <el-row>
            <el-col :span="24">
              <div class="container-message-commercial">
                <div class="box-commercial">
                  <p>{{ $t('posts.networks.commercialText1') }} <strong>{{networkName}}</strong> {{ $t('posts.networks.commercialText1Bis')}}</p>
                  <p>{{$t('posts.networks.commercialText2')}}</p>
                  <p>{{$t('posts.networks.commercialText3')}} <strong>{{networkName}}</strong>  {{ $t('posts.networks.commercialText3Bis')}}</p>
                  <div class="text-center">
                    <el-button type="primary" v-if="!isSubUser" @click="contactTeam"> Soyez recontacté par notre équipe.</el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <template v-if="browserContext.up('md')">
        <hr/>
        <div class="text-right"  v-if="possedeSocialNetwork">

          <el-dropdown placement="top" @command="handleplanningActions" v-if="(statusPost !== 'isCurrentlyPublished') && statusPost !== 'published' && !isCurrentlyPublished" >
            <el-button type="primary" >
              <i class="el-icon-date"></i> Gérer la planification
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item  v-if="statusPost === 'no planned' && !editSchedule" command="planned"><i class="el-icon-date"></i> {{$t('general.calendar.scheduled')}}</el-dropdown-item>
              <el-dropdown-item  v-if="statusPost === 'no planned' && !editSchedule" command="published"><i class="el-icon-share"></i> {{$t('general.calendar.publishNow')}}</el-dropdown-item>
              <el-dropdown-item  v-if="checkDisplayButtonPost" command="edited"><i class="el-icon-edit"></i> {{$t('general.calendar.edit')}}</el-dropdown-item>
              <el-dropdown-item  v-if="checkDisplayButtonPost" command="trashed"><i class="el-icon-delete"></i> {{$t('general.calendar.delete')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="mx-3" placement="top" @command="handlePostActions">
            <el-button type="primary" :disabled="(statusPost === 'isCurrentlyPublished') || isCurrentlyPublished || statusPost === 'published'">
              <i class="el-icon-document-checked"></i> Gérer le post
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="this.$route.params.id" command="save"><i class="el-icon-check"></i>  {{ $t("posts.edit.saveModifications") }}</el-dropdown-item>
              <el-dropdown-item command="cancel"><i class="el-icon-close"></i> {{ $t("posts.edit.cancel") }}</el-dropdown-item>
              <el-dropdown-item v-if="fromNewPost" command="back"><router-link :to="{name: 'social-posts'}"><i class="el-icon-back"></i> {{$t("posts.list.backToPostsList")}} </router-link></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <ButtonScrollToTop @goToTop="goToTop" @scroll="handleScroll" v-if="buttonIsVisible"/>
    </div>
    <div v-else>
      <el-container>
        <el-aside width="30%">
          <h3>{{ $t('posts.clap.toKnowTitle') }}</h3>
          <p class="text-justify" v-html="$t('posts.clap.toKnowText')"/>
          <h3 style="color: red;">{{ $t('posts.clap.attentionTitle') }} !</h3>
          <p class="text-justify" style="color: red;" v-html="$t('posts.clap.attentionText')"/>
        </el-aside>
        <el-main v-if="possedeClapVideo">
          <el-row>
            <el-col :span="24">
              <h4>{{ titleH4 }}</h4>
              <p>
                <strong>{{ $t('posts.clap.forfaitClapTitle') }}</strong>
                <br/>
                {{
                  $t('posts.clap.forfaitClap', {
                    'quotaMax': this.getQuotaMax,
                    'nbClapRestants': this.getNbClapRestants
                  })
                }}
              </p>
              <p>
                <strong>{{ $t('posts.clap.monitoringClapTitle') }}</strong>
                <br/>
                {{
                  $t('posts.clap.monitoringClap', {
                    'nbClapGeneres': this.getNbClapGeneres,
                    'nbClapRestants': this.getNbClapRestants
                  })
                }}
                <el-tooltip placement="top-start" :content="$t('posts.clap.monitoringClapTooltip')">
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </p>
            </el-col>

            <el-col v-if="getHasUrlClapVideo" :span="24">
              <br/><br/>
              <el-button @click="openUrlClap">{{ $t('posts.clap.downloadClapButton') }}</el-button>
            </el-col>
            <el-col v-else :span="24">
              <br/><br/>
              <div v-if="getClapInProgress === true">
                <p v-html="$t('posts.clap.patientTextBegin')"></p>
                <el-button @click="checkUrlClap">{{ $t('posts.clap.checkUrlClapButton') }}</el-button>
                <br/><br/>
                <p v-html="$t('posts.clap.patientTextEnd')"></p>
              </div>
              <div v-else>
                <el-button type="primary" @click="clickGenerateClap">{{
                    $t('posts.clap.generateClapButton')
                  }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-main>
        <el-main v-else>
          <el-row>
            <el-col :span="24">
              <strong>{{ $t('posts.clap.disabledText') }}</strong>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <template v-if="browserContext.up('md')">
        <hr/>
        <div class="text-right">
          <el-row v-if="(possedeClapVideo) && !this.urlClap">
            <router-link :to="{ name: 'social-posts' }" v-if="fromNewPost" style="margin-right: 15px">
              <el-button>Retour à la liste des posts</el-button>
            </router-link>
            <el-button @click="annuler">{{ $t('posts.edit.cancel') }}</el-button>
          </el-row>
        </div>
      </template>
    </div>
  </ubi-panel>
</template>
<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { modalDeletedPostMixin } from '@/mixins/modalDeletedPostMixin'
import { modalPostSocialNetworksMixin } from '@/mixins/modalPostSocialNetworksMixin'
import DateTimePickerPost from '@/pages/posts/components/DateTimePickerPost.vue'
import Emoji from '@/components/emojis/Emoji.vue'
import { generateAutoclap } from '@/services/clap'
import { getDiffusionAnnonces } from '@/services/portals'
import Stretch from '@/components/spinners/Stretch.vue'
import { getDiffuseur } from '@/helpers/functions/diffuseur'
import { $t } from '@/i18n'
import browserContext from '@/components/BrowserContext.vue'
import { getPostById } from '@/services/posts'
import UbiPanel from '@/components/Panel.vue'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop.vue'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'
import { CREATE } from '@/helpers/constantes/promptConstants'
import PostVideoFileUrlCustom from '@/pages/posts/components/PostVideoFileUrlCustom.vue'

export default {
  name: 'ManagePostNetwork',
  props: ['post', 'networkName', 'fromNewPost', 'networkEvent', 'currentTab', 'titleH3', 'titleH4', 'titleH3Info', 'textAsideInfo1', 'textAsideInfo2', 'textInfoIA', 'titleWarning', 'textWarning', 'textAside', 'textInfoTextarea1', 'textInfoTextarea2','notActivated', 'actionEnregistrer', 'actionAnnuler', 'valueName', 'possedeRS', 'getCaption'],
  inject: ['browserContext'],
  mixins: [modalDeletedPostMixin, buttonScrollToTopMixin, modalPostSocialNetworksMixin],
  components: {
    PostVideoFileUrlCustom,
    ButtonScrollToTop,
    UbiPanel,
    Stretch,
    DateTimePickerPost,
    Emoji
  },
  data () {
    return {
      datePost: null,
      selectedPrompt: null,
      isScrolled: 0,
      statusPost: null,
      editSchedule: false,
      isDatePickerVisible: false,
      isCurrentlyPublished: false,
      codeNetwork: null,
      valueNetwork: null,
      quotaMax: 0,
      nbClapGeneres: 0,
      nbClapRestants: 0,
      diffusionClap: null,
      urlClap: null,
      clapInProgress: false,
      errors: {}
    }
  },
  watch: {
    currentTab: {
      handler (val, oldVal) {
        if (val !== oldVal && val !== 'Video') {
          if (this.IAoptionPersonnalisationPromptActive) {
            const infos = {
              annonceurId: this.sitimmoUser.id,
              diffuseurId: this.getDiffuseurByName(getDiffuseur(val, this.universe, this.isBienVendu))
            }
            this.$store.commit('promptLibraries/setInfos', infos)
            this.$store.dispatch('promptLibraries/loadLibraryPromptByDiffuseur')
          }
          this.$store.watch.currentTab = null
        }
      },
      immediate: true
    }
  },
  computed: {
    browserContext () {
      return browserContext
    },
    ...mapState('posts', ['filter']),
    ...mapGetters(['isSubUser', 'isImmo', 'isVo', 'isPromoteur', 'isCmi', 'IAoptionPersonnalisationPromptActive', 'IAoptionActive', 'hasOptionIaAndPersoPrompt', 'hasFlux']),
    ...mapGetters('storeClap', ['getHasPost', 'getHasUrlClap', 'getQuotaMax', 'getNbClapRestants', 'getNbClapGeneres', 'getClapInProgress']),
    ...mapGetters('diffuseurs', ['getDiffuseurByName']),
    ...mapGetters('promptLibraries', ['getLibrariePrompt']),
    ...mapState('storeClap', ['posts']),
    ...mapMutations('storeClap', ['deletePost']),
    user () {
      return this.$store.state.app.user
    },
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    possedeSocialNetwork () {
      return this.possedeRS
    },
    getDatePost () {
      if (this.networkEvent && this.networkEvent[0]) {
        this.datePost = this.networkEvent[0].start
      }
      return this.datePost
    },
    getStatusPost () {
      if (this.networkEvent && this.networkEvent.length <= 0) {
        this.statusPost = 'no planned'
      } else if (this.networkEvent && this.networkEvent[0] && this.networkEvent[0].scheduled.lastExecution !== null) {
        this.statusPost = 'published'
      } else if (this.networkEvent && this.networkEvent[0] && this.networkEvent[0].status === 'isCurrentlyPublished') {
        this.statusPost = 'isCurrentlyPublished'
      } else {
        this.statusPost = 'planned'
      }
      return this.statusPost
    },
    checkIsVisibleDatePicker () {
      return this.getStatusPost !== 'no planned' && this.networkEvent && this.networkEvent.length > 0
    },
    isPlanned () {
      return (this.statusPost && this.statusPost !== 'published' && this.statusPost !== 'no planned')
    },
    isAlreadyPublished () {
      return (this.statusPost === 'isCurrentlyPublished') || this.isCurrentlyPublished || this.getStatusPost === 'published'
    },
    checkDisplayButtonPost () {
      return this.isPlanned && !this.isCurrentlyPublished
    },
    caption: {
      get () {
        return this.getCaption
      },
      set (val) {
        this.$emit('update:caption', val)
      }
    },
    getMessageFlash () {
      return this.$store.getters['caption/getMessage']
    },
    getNetworkDiffuseur () {
      return getDiffuseur(this.currentTab, this.universe, this.isBienVendu)
    },
    possedeClapVideo () {
      return this.user.possedeClap
    },
    getHasUrlClapVideo () {
      return !!((this.currentTab === 'Video' && this.getHasUrlClap(this.$route.params.id).length > 0))
    },
    isNeedSocialNetwork () {
      // forçage de l'émetteur SOCIAL_NETWORK dans le cas où l'annonceur n'a pas d'émetteur saisie_*
      return !this.$store.state.app.sitimmoUser.saisit_annonces_en_ligne && !this.$store.state.app.sitimmoUser.saisit_en_ligne_et_flux
    },
    getLoadingCaption () {
      return this.$store.getters['caption/getIsLoadingCaption']
    },
    isBienVendu () {
      return this.$route.name.split('-').pop() === 'vendu'
    },
    hasOnlyOptionIa () {
      return this.sitimmoUser.optionIa && !this.sitimmoUser.personnalisationPrompts
    }
  },
  methods: {
    ...mapActions('calendarSocialPosts', ['createEventNow']),
    contactTeam () {
      window.open('https://www.ubiflow.net/annonces-immobilieres-google-facebook-instagram')
    },
    setError (errorKey, errorMessage) {
      if (errorMessage === 'delete') {
        delete this.errors[errorKey]
      } else {
        this.errors[errorKey] = errorMessage
      }
    },
    updateCurrentTab (tabName) {
      this.$emit('change-tab', tabName)
    },
    async checkDiffusionCurrenltyPublished () {
      if (this.networkName !== 'Video') {
        const result = await getDiffusionAnnonces({
          annonce: this.$route.params.id,
          diffuseurCode: this.getNetworkDiffuseur
        })
        if (result.list.length > 0) {
          const diffuseurNameOfResult = result.list[0].diffuseurName.split(' ')[0].toLowerCase()
          if (diffuseurNameOfResult === this.networkName.split('_')[0].toLowerCase()) {
            this.isCurrentlyPublished = result.list[0].isCurrenltyPublished
          }
        }
      }
    },
    resetCaption () {
      const titleDialog = this.hasOptionIaAndPersoPrompt ? $t('prompt.resetPrompt') : $t('posts.adResetDialogTitle')
      const textDialog = this.hasOptionIaAndPersoPrompt ? $t('prompt.resetPromptDialog') : $t('posts.adResetDialog')
      this.$confirm(titleDialog, textDialog, {
        confirmButtonText: $t('prompt.validate'),
        cancelButtonText: $t('prompt.cancel'),
        type: 'info'
      }).then((response) => {
        if (response === 'confirm') {
          this.$store.dispatch('caption/resetCaption', { network: this.currentTab, universe: this.universe, post: this.post, bienVendu: this.isBienVendu })
        }
      })
    },
    validateDateTime (args) {
      const [dateTime, status] = args
      this.statusPost = status
      this.datePost = dateTime
      this.modalPost()
      this.editSchedule = false
    },
    lostFocusDatePicker (etat) {
      this.isDatePickerVisible = etat
    },
    handleplanningActions (command) {
      switch (command) {
        case 'planned':
        case 'published':
          if (Object.keys(this.errors).length > 0) {
            for (const errorKey in this.errors) {
              this.$message({ message: this.errors[errorKey], type: 'error', duration: 4000 })
            }
          } else {
            this.$store.dispatch('caption/updateCaption', { caption: this.caption, login: this.sitimmoLogin, post: this.post, emission: this.post.emission, isNeedSocialNetwork: this.isNeedSocialNetwork })
            this.planningAction(command)
          }
          break
        case 'edited':
          this.editScheduled()
          break
        default:
          this.deleteScheduled()
      }
    },
    handlePostActions (command) {
      switch (command) {
        case 'save':
          this.saveCaption()
          break
        default:
          this.annuler()
      }
    },
    editScheduled () {
      this.editSchedule = true
      this.$store.dispatch('calendarSocialPosts/deleteScheduled', this.networkEvent)
      this.isDatePickerVisible = true
      this.$nextTick(() => this.$refs.datePicker.$refs.picker.focus())
    },
    planningAction (etat) {
      this.currentEtat = etat
      // Si on publie maintenant => date aujourd'hui
      if (this.currentEtat === 'planned') {
        this.isDatePickerVisible = true
        // Si on planifie ajouter le focus sur le datetimePicker
        this.$nextTick(() => this.$refs.datePicker.$refs.picker.focus())
      } else {
        const tzoffset = (new Date()).getTimezoneOffset() * 60000
        const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1)
        this.datePost = localISOTime.split('.')[0]
        this.modalPost()
      }
    },
    handleActive () {
      this.isActive = !this.isActive
    },
    addEmoji (emoji) {
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaNetwork.$el.querySelector('.el-textarea__inner')

      let cursorIndex = textarea.selectionEnd
      const textIA = this.getCaption.text
      this.getCaption.text = textIA.substring(0, cursorIndex) + insertText + textIA.substring(cursorIndex)
      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    saveCaption () {
      if (this.caption.text.length > 2200 && this.networkName === 'Instagram') {
        this.$message({ type: 'info', message: $t('posts.networks.instagram.popupNumberCharacters') })
      } else if (Object.keys(this.errors).length > 0) {
        for (const errorKey in this.errors) {
          this.$message({ message: this.errors[errorKey], type: 'error', duration: 4000 })
        }
      } else {
        const saveCaption = this.$store.dispatch('caption/updateCaption', { caption: this.caption, login: this.sitimmoLogin, post: this.post, emission: this.post.emission, isNeedSocialNetwork: this.isNeedSocialNetwork })
        saveCaption.then(() => {
          this.getMessageFlash
          this.$message({ type: 'success', message: $t('posts.dialog.adUpdatedNotification') })
        })
      }
    },
    annuler () {
      this.$ga.event('annonce', 'clic', 'annuler_instagram', this.sitimmoUser.id)
      this.$router.go(-1) // parent is in charge
    },
    checkUrlClap () {
      if (this.post) {
        getPostById(this.$route.params.id).then((post) => {
          if (post.url_clap) {
            this.urlClap = post.url_clap
            this.$message({ message: this.$t('posts.clap.msgClapEnded'), type: 'success', duration: 5000 })
            this.$store.commit('storeClap/setUrlClap', { id: post.id, url_clap: post.url_clap })
            this.$store.commit('storeClap/setClapInProgress', false)
          } else {
            this.$message({ message: this.$t('posts.clap.msgClapInProgress'), type: 'info', duration: 5000 })
          }
        })
      }
    },
    openUrlClap () {
      window.open(this.post.url_clap, '_blank')
    },
    clickGenerateClap () {
      this.$message({ message: this.$t('posts.clap.msgClapLaunch'), type: 'info', duration: 5000 })
      this.$store.commit('storeClap/setClapInProgress', true)
      generateAutoclap(this.post).then((response) => {
        if (response.type === 'error') {
          this.$message({ message: response.message, type: 'error', duration: 10000 })
          this.$store.commit('storeClap/setClapInProgress', false)
        } else {
          this.$store.dispatch('storeClap/checkQuotaClap', { universe: this.universe, possedeClap: this.possedeClapVideo })
          if (this.post) {
            this.$store.commit('storeClap/setPostStatus', this.post)
            if (this.post.url_clap) {
              this.urlClap = this.post.url_clap
              this.$store.commit('storeClap/setUrlClap', {
                id: this.post.id,
                url_clap: this.post.url_clap
              })
            } else {
              this.$store.commit('storeClap/setClapInProgress', true)
            }
          }
        }
      })
    },
    handleSelectedPrompt () {
      this.$confirm($t('prompt.selectedPromptIAGenerated'), $t('prompt.selectedPrompt'), {
        confirmButtonText: $t('prompt.validate'),
        cancelButtonText: $t('prompt.cancel'),
        type: 'info'
      })
        .then((response) => {
          if (response === 'confirm') {
            this.$store.dispatch('promptLibraries/findPromptAndSend', { promptId: this.selectedPrompt, diffuseurName: this.getNetworkDiffuseur, post: this.post, isNeedSocialNetwork: this.isNeedSocialNetwork, isBienVendu: this.isBienVendu })
          }
          if (response === 'cancel') {
            this.$message({
              type: 'error',
              message: $t('prompt.selectedFailed')
            })
          }
        }).finally(() => {
          this.selectedPrompt = ''
        })
    },
    redirectToPromptsLibraries () {
      this.$router.push({ path: '/prompt-libraries', query: { action: CREATE } })
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.network) {
      const network = this.$route.query.network
      this.currentTab = network.charAt(0).toUpperCase() + network.slice(1)
    }
  },
  updated () {
    this.codeNetwork = this.getNetworkDiffuseur
  },
  beforeMount () {
    if (this.getHasUrlClapVideo.length > 0 && this.networkName === 'Video') {
      this.urlClap = this.getHasUrlClapVideo[0].url
    }
    if (this.networkName === 'Video') {
      this.$store.dispatch('storeClap/checkQuotaClap', { universe: this.universe, possedeClap: this.possedeClapVideo })
    }
    this.checkDiffusionCurrenltyPublished()
  }
}
</script>
<style scoped>
.main-container{
  min-height: 600px;
}
.textarea-with-emojis{
  position: relative;
}
.box-emojis{
  position: absolute;
  bottom: 0;
  right: 10px;
}
.wait-captionIA {
  width: 100%;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wait-captionIA p {
  width: 350px;
  font-weight: 600;
  color: #0ab1bf;
}

.container-message-commercial{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box-commercial{
  max-width: 75%;
}

.paragrah {
  margin-top: -15px;
}

/* Module creation prompt */
.create-prompt-module{
  margin-top: 20px;
}

/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0.5;
}

/*
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}*/
</style>
